import { IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

interface CancelButtonProps {
  onClose: () => void;
}

export const CancelButton = ({ onClose }: CancelButtonProps) => {
  return (
    <IconButton size='small' onClick={onClose} sx={{ paddingLeft: 1 }}>
      <Tooltip title={'Cancel'}>
        <CloseIcon color='action' sx={{ width: 20, height: 20 }} />
      </Tooltip>
    </IconButton>
  );
};
